document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-brand-collection-description]');
  if (!root || window.innerWidth > 749) return;

  const shortDesc = root.querySelector('.brand-collection__description-short');
  const fullDesc = root.querySelector('[data-description-full]');
  const expandBtn = root.querySelector('[data-description-toggle="expand"]');
  const collapseBtn = root.querySelector('[data-description-toggle="collapse"]');

  if (!shortDesc || !fullDesc || !expandBtn || !collapseBtn) return;

  expandBtn.addEventListener('click', () => {
    shortDesc.hidden = true;
    fullDesc.hidden = false;
  });

  collapseBtn.addEventListener('click', () => {
    fullDesc.hidden = true;
    shortDesc.hidden = false;
  });
});
